import { PureComponent } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import PropTypes from 'prop-types';

import { KeyboardNavigationProvider } from 'components/KeyboardNavigationContext';
import DeviceProvider from '../DeviceProvider';
import Routes from './Routes';
import * as actions from './actions';
import WkdaLogger from '../WkdaLogger';

export { default as getMatched } from './Routes/getMatched';

export default class App extends PureComponent {
  static propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    device: PropTypes.object.isRequired,
  };

  render() {
    const { store, history, device } = this.props;

    return (
      <ReduxProvider store={store}>
        <ConnectedRouter history={history}>
          <DeviceProvider value={device}>
            <KeyboardNavigationProvider>
              <WkdaLogger>
                <Routes />
              </WkdaLogger>
            </KeyboardNavigationProvider>
          </DeviceProvider>
        </ConnectedRouter>
      </ReduxProvider>
    );
  }
}

App.actions = actions;
